let Global = {
    store: {
        namespaced: true
    },
    components: {},
    api: {}
};